import {PrinterIcon} from '@/components/ui/icon/Icon'
import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {PrintSiarDialog, isPrintSiarEnabled} from '@/features/projects/components/print-siar-dialog/PrintSiarDialog'
import {ProjectIndex} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'

export const ProjectOptionPrintSiarMenuItem = ({project}: {project: ProjectIndex}) => {
    const {t} = useTranslation()

    if (!project.status || !project.progressStatus) {
        return null
    }

    // When disabled the dialog can never open, so we skip it entirely and show a
    // standalone disabled item wrapped in a tooltip that explains why.
    if (!isPrintSiarEnabled(project.status, project.progressStatus)) {
        return (
            <Tooltip variant="light" content={t('projects:print_siar_disabled_tooltip')} triggerProps={{asChild: true}}>
                {/* The span is the hover target: a disabled control can't reliably fire the
                    pointer events Radix needs, so we wrap it (canonical Radix pattern). */}
                <span style={{display: 'block'}}>
                    <MenuItem disabled onClick={e => e.preventDefault()}>
                        <PrinterIcon />
                        {t('projects:print_siar')}
                    </MenuItem>
                </span>
            </Tooltip>
        )
    }

    return (
        <PrintSiarDialog
            projectId={project.id}
            status={project.status}
            progressStatus={project.progressStatus}
            projectCode={project.code}
            customTrigger={({onClick}) => (
                <MenuItem
                    onClick={e => {
                        e.preventDefault()
                        onClick(e)
                    }}
                >
                    <PrinterIcon />
                    {t('projects:print_siar')}
                </MenuItem>
            )}
        />
    )
}
